import { render, staticRenderFns } from "./PatternCategoryCluster.vue?vue&type=template&id=1bb31dca&scoped=true&"
import script from "./PatternCategoryCluster.vue?vue&type=script&lang=js&"
export * from "./PatternCategoryCluster.vue?vue&type=script&lang=js&"
import style0 from "./PatternCategoryCluster.vue?vue&type=style&index=0&id=1bb31dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb31dca",
  null
  
)

export default component.exports